import { Controller } from "@hotwired/stimulus";
// import throttle from 'lodash.throttle'

export default class extends Controller {
  static targets = ["gradesSelect"];
  static values = {
    submitOnConnect: Boolean,
  };

  connect() {
    if (this.submitOnConnectValue) {
      this.submit();
    }
  }

  submit() {
    this.element.requestSubmit(); // Programatically submit the form.
  }

  updateGrades(e) {
    e.preventDefault();

    const target = e.target;
    let options = [];
    switch (target.value) {
      case "PK-2":
        options = ["PK", "K", "1", "2"];
        break;
      case "3-5":
        options = ["3", "4", "5"];
        break;
      case "6-12":
        options = ["6", "7", "8", "9", "10", "11", "12"];
        break;
      default:
        break;
    }
    Array.from(this.gradesSelectTarget.options).forEach(function (option) {
      if (options.includes(option.value)) {
        option.selected = true;
      } else {
        option.selected = false;
      }
    });
    
    // Update Tom Select instance if it exists
    if (this.gradesSelectTarget.tomselect) {
      this.gradesSelectTarget.tomselect.setValue(options);
    } else {
      // Fallback: dispatch change event for non-Tom Select instances
      const evt = new Event("change");
      this.gradesSelectTarget.dispatchEvent(evt);
    }
    
    // Only submit if this is a GET form (like in discovery/insights views)
    // For POST forms (like alerts), don't auto-submit
    if (this.element.method === "get" || !this.element.method) {
      this.submit();
    }
  }

  clear(e) {
    // e.preventDefault();
    const target = e.target;
    const { href, search } = window.location;
    const params = new URLSearchParams(search);
    const obj = {
      criteria_value: params.get("criteria_value"),
      criteria_type: params.get("criteria_type"),
      criteria_percentage: params.get("criteria_percentage"),
    };
    Object.keys(obj).forEach((k) => obj[k] == null && delete obj[k]);
    const new_params = new URLSearchParams(obj);
    target.href = `${target.href}&${new_params.toString()}`;
  }
}
